'use strict';

Object.defineProperty(exports, "__esModule", {
            value: true
});

var _utils = require('../../src/utils/utils.js');

var _utils2 = _interopRequireDefault(_utils);

var _dom = require('../../src/utils/dom.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

            methods: {
                        cellEdit: function cellEdit(e, callback, rowIndex, rowData, field, editType, Vue) {
                          var self = this;
                                    var target = e.target,
                                        self = this,
                                        oldVal = void 0,
                                        editInput = void 0,
                                        editInputLen = void 0,
                                        _actionFun = void 0,
                                        _sleItem = void 0,
                                        _clickBody = void 0,
                                        textAlign = void 0,
                                        childTarget = void 0;

                                    while (target.className && target.className.indexOf('v-table-body-cell') === -1 || !target.className) {
                                      if(_dom.hasClass(target, 'ivu-date-picker')) {
                                        return false
                                      } else {
                                        target = target.parentNode;
                                      }
                                    }
                                    childTarget = target.children[0];

                                    oldVal = childTarget.innerText.trim();

                                    if (target.style.textAlign) {

                                                textAlign = target.style.textAlign;
                                    }
                                    if(editType === 'time') {
                                      if ((0, _dom.hasClass)(target, 'cell-editing')) {
                                        return false;
                                      }

                                      (0, _dom.addClass)(target, 'cell-editing');
                                      childTarget.style.display = 'none';
                                      var datePic = Vue.extend({
                                        render: function(h) {
                                          var _this = this;
                                          return h('DatePicker', {
                                            class: {
                                              operate: true
                                            },
                                            props: {
                                              value: oldVal,
                                              editable: false
                                            },
                                            on: {
                                              'on-change': function (newVal) {
                                                if ((0, _dom.hasClass)(target, 'cell-editing')) {

                                                  (0, _dom.removeClass)(target, 'cell-editing');
                                                } else {
                                                  return false;
                                                }
                                                callback(newVal, oldVal);
                                                childTarget.style.display = '';
                                                target.removeChild(_this.$el);
                                              },
                                              'on-clickoutside': function (e) {
                                                if ((0, _dom.hasClass)(target, 'cell-editing')) {

                                                  (0, _dom.removeClass)(target, 'cell-editing');
                                                } else {
                                                  return false;
                                                }
                                                childTarget.style.display = '';
                                                target.removeChild(_this.$el);
                                                while (e.target.className && e.target.className.indexOf('v-table-body-cell') === -1 || !e.target.className) {
                                                  e.target = e.target.parentNode;
                                                }
                                                e.target.click()
                                              }
                                            }
                                          })
                                        }
                                      })
                                      // 创建 Profile 实例，并挂载到一个元素上。
                                      var compent = new datePic().$mount();
                                      target.appendChild(compent.$el);
                                      var editInput = compent.$el.querySelector('.ivu-input')
                                      editInput.click()
                                    } else if(editType === 'select') {
                                      var parent = document.querySelector('.page-table-box .v-table-body');
                                      var copyTar = target
                                      var tarW = copyTar.offsetWidth;
                                      var tarH = copyTar.offsetHeight;
                                      var parW = parent.clientWidth;
                                      var parH = parent.clientHeight;
                                      var top = copyTar.offsetTop, left = copyTar.offsetLeft;
                                      while (copyTar.offsetParent !== parent) {
                                        copyTar = copyTar.offsetParent
                                        top+= copyTar.offsetTop;
                                        left+= copyTar.offsetLeft;
                                      }
                                      var ulDom = document.createElement('ul');
                                      ulDom.innerHTML = '<li class="table-el-item">是</li>\n' +
                                        '<li class="table-el-item">否</li>';
                                      ulDom.className = 'table-sel'
                                      ulDom.style.width = tarW+'px';
                                      if((tarH+top + 80) > parH ) {
                                        ulDom.style.top = top+'px';
                                        ulDom.style.left = left+ 'px';
                                        ulDom.style.transform = 'translateY(-100%)'
                                      } else {
                                        ulDom.style.top = (tarH+top)+'px';
                                        ulDom.style.left = left+ 'px';
                                      }
                                      parent.appendChild(ulDom)
                                      _sleItem = function (e) {
                                        e.stopPropagation();
                                        if(e.target.className === 'table-el-item') {
                                          var newVal = e.target.innerText.trim();
                                          if(newVal === oldVal) {
                                            return
                                          }
                                          callback(newVal, oldVal);
                                          _utils2.default.unbind(ulDom, 'click', _sleItem);
                                          parent.removeChild(ulDom)
                                        }
                                      }
                                      _utils2.default.bind(ulDom, 'click', _sleItem);
                                    }else {
                                      if ((0, _dom.hasClass)(target, 'cell-editing')) {
                                        return false;
                                      }

                                      (0, _dom.addClass)(target, 'cell-editing');
                                      childTarget.style.display = 'none';
                                      editInput = document.createElement('input');
                                      editInput.value = oldVal;
                                      editInput.className = 'cell-edit-input';
                                      editInput.style.textAlign = textAlign;
                                      editInput.style.width = '100%';
                                      editInput.style.height = '100%';
                                      target.appendChild(editInput);
                                      editInput.focus();
                                      editInputLen = editInput.value.length;
                                      if (document.selection) {
                                        var ctr = editInput.createTextRange();
                                        ctr.moveStart('character', editInputLen);
                                        ctr.collapse();
                                        ctr.select();
                                      } else if (typeof editInput.selectionStart == 'number' && typeof editInput.selectionEnd == 'number') {
                                        editInput.selectionStart = editInput.selectionEnd = editInputLen;
                                      }
                                      _actionFun = function actionFun(e) {
                                        if (e.target.value !== '' && e.target.value !== undefined) {
                                          e.target.value = String(e.target.value.replace(/(^\s*)/g, '').slice(0, 20))
                                        }
                                        if (typeof e.keyCode === 'undefined' || e.keyCode === 0 || e.keyCode == 13) {

                                          if ((0, _dom.hasClass)(target, 'cell-editing')) {

                                            (0, _dom.removeClass)(target, 'cell-editing');
                                          } else {
                                            return false;
                                          }

                                          childTarget.style.display = '';

                                          callback(editInput.value, oldVal);

                                          _utils2.default.unbind(editInput, 'blur', _actionFun);
                                          _utils2.default.unbind(editInput, 'keydown', _actionFun);

                                          target.removeChild(editInput);
                                        }
                                      };

                                      _utils2.default.bind(editInput, 'blur', _actionFun);
                                      _utils2.default.bind(editInput, 'keydown', _actionFun);
                                      _utils2.default.bind(editInput, 'keyup', _actionFun);
                                    }
                        }
            }
};
